<template>
  <div class="thirdPage">
    <div class="head">
      <img src="/static/imgs/secondPage/sun.png" />
      <span class="back">IMMERSIVE</span>
      <span class="front">我们的沉浸式产品</span>
    </div>
    <div>
      <el-row type="flex" class="products row-bg" justify="space-around" :gutter="20">
        <el-col v-for="(item,index) in products" :key="index" :style="{'margin-top':(index%2==0?'40px':'-40px')}">
          <div class="title">
            <span>{{item.title}}</span>
          </div>
          <div class="content">
            <span>{{item.content}}</span>
          </div>
        </el-col>
      </el-row>

    </div>
  </div>

</template>

<script>
export default {
  name: "thirdPage",
  data() {
    return {
      products: [
        {
          title: "【沉浸式培训】",
          content: "跨界载体的高峰体验与知识技能相结合的新型培训",
        },
        {
          title: "【沉浸式活动】",
          content: "将沉浸式活动作为学习的辅助手段，提高学习效果与产出",
        },
        {
          title: "【沉浸式工作坊】",
          content: "基于客户需求的主题式引导工作坊",
        },
        {
          title: "【沉浸式项目】",
          content: "基于综合性沉浸式体验应用的咨询项目",
        },
      ],
    };
  },
};
</script>
<style lang="less" scoped>
.thirdPage {
  margin: 100px 0 0 0;
  background-color: whitesmoke;
  padding: 140px 0 0 0;
}
.head {
  text-align: center;

  img {
    margin-left: -250px;
  }
  .back {
    position: absolute;
    font-size: 55px;
    color: cornflowerblue;
    margin-left: -90px;
    margin-top: -10px;
    z-index: 0;
    opacity: 0.2;

  }
  .front {
    position: absolute;
    font-size: 45px;
    margin-top: 22px;
    margin-left: -65px;
    margin-top: 10px;
    letter-spacing: 8px;
  }
}

.products {
  margin-top: 100px;
  .title {
    color: #233b8e;
    font-weight: bold;
    font-family: "黑体";
    font-size: 28px;
  }
  .content {
    margin-top: 10px;
    color: #233b8e;
    font-weight: 100;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/thirdPage.vue